/**
 * AFW Vehicle Bar — Global top-of-page search
 * Year → Make → Model → Category → SEARCH
 * Wheels → iConfigurator | Tires → TireConnect | Rest → Shopify search
 */
(function () {
  'use strict';

  var NHTSA_BASE = 'https://vpic.nhtsa.dot.gov/api/vehicles';

  var COMMON_MAKES = [
    'Acura', 'Alfa Romeo', 'Audi', 'BMW', 'Buick', 'Cadillac',
    'Chevrolet', 'Chrysler', 'Dodge', 'FIAT', 'Ford', 'Genesis',
    'GMC', 'Honda', 'Hyundai', 'INFINITI', 'Jaguar', 'Jeep',
    'Kia', 'Land Rover', 'Lexus', 'Lincoln', 'Maserati', 'Mazda',
    'Mercedes-Benz', 'MINI', 'Mitsubishi', 'Nissan', 'Porsche',
    'Ram', 'Rivian', 'Subaru', 'Tesla', 'Toyota', 'Volkswagen',
    'Volvo'
  ];

  /* Category → destination routing */
  var ROUTES = {
    'wheels':       { type: 'widget', url: '/pages/wheels' },
    'tires':        { type: 'widget', url: '/pages/tires' },
    'suspension':   { type: 'search', kw: 'suspension' },
    'lift-kits':    { type: 'search', kw: 'lift kit' },
    'lowering-kits':{ type: 'search', kw: 'lowering' },
    'lighting':     { type: 'search', kw: 'lighting' },
    'exhaust':      { type: 'search', kw: 'exhaust' },
    'audio':        { type: 'search', kw: 'audio' },
    'all-services': { type: 'page',   url: '/pages/all-services' }
  };

  var cache = {};

  /* ================================================
     Helpers
     ================================================ */
  function $(id) { return document.getElementById(id); }

  function addOpt(select, value, text) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = text;
    select.appendChild(o);
  }

  function showLoader() {
    var l = $('afw-vbar-loader');
    if (l) l.style.display = '';
  }
  function hideLoader() {
    var l = $('afw-vbar-loader');
    if (l) l.style.display = 'none';
  }

  /* ================================================
     NHTSA API — model lookup with dual-layer cache
     ================================================ */
  function fetchModels(make, year, callback) {
    var key = make + '_' + year;

    /* Memory cache */
    if (cache[key]) { callback(cache[key]); return; }

    /* sessionStorage cache */
    try {
      var stored = sessionStorage.getItem('afw_models_' + key);
      if (stored) {
        var parsed = JSON.parse(stored);
        cache[key] = parsed;
        callback(parsed);
        return;
      }
    } catch (e) { /* ignore */ }

    /* Fetch from NHTSA */
    showLoader();
    var url = NHTSA_BASE + '/GetModelsForMakeYear/make/' +
      encodeURIComponent(make) + '/modelyear/' + year + '?format=json';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var models = [];
        if (data.Results && data.Results.length) {
          data.Results.forEach(function (r) {
            if (r.Model_Name) models.push(r.Model_Name);
          });
        }
        models = models
          .filter(function (v, i, a) { return a.indexOf(v) === i; })
          .sort();

        cache[key] = models;
        try { sessionStorage.setItem('afw_models_' + key, JSON.stringify(models)); }
        catch (e) { /* ignore */ }

        hideLoader();
        callback(models);
      })
      .catch(function () {
        hideLoader();
        callback([]);
      });
  }

  /* ================================================
     Session persistence (same key as afw-vehicle-finder)
     ================================================ */
  function saveVehicle(year, make, model) {
    try {
      sessionStorage.setItem('afw_vehicle', JSON.stringify({
        year: year, make: make, model: model
      }));
    } catch (e) { /* ignore */ }
  }

  function loadVehicle() {
    try {
      var s = sessionStorage.getItem('afw_vehicle');
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }

  /* ================================================
     Routing — where to send the user
     ================================================ */
  function performSearch(year, make, model, category) {
    saveVehicle(year, make, model);

    var route = ROUTES[category];
    if (!route) return;

    var vp = 'year=' + encodeURIComponent(year) +
      '&make=' + encodeURIComponent(make) +
      '&model=' + encodeURIComponent(model);

    switch (route.type) {
      case 'widget':
        /* Redirect to wheels/tires page with vehicle params */
        window.location.href = route.url + '?' + vp + '&afw_vbar=1';
        break;

      case 'search':
        /* Shopify search with category keyword only.
           Vehicle name is NOT included in the query because Shopify
           uses OR-matching and would return unrelated products that
           merely match the make/model.  Vehicle params are passed
           separately so the search-enhancer can filter + display
           the vehicle context banner. */
        window.location.href = '/search?type=product&q=' +
          encodeURIComponent(route.kw) + '&' + vp;
        break;

      case 'page':
        window.location.href = route.url;
        break;
    }
  }

  /* ================================================
     TireConnect bridge — pre-populate vehicle search
     Runs on /pages/tires when vehicle data is available.
     The widget instance lives at TCWidget.loadedApps.TCWidgetSearch
     and exposes .searchByVehicle({ year, make, model }).
     ================================================ */
  function initTireConnectBridge() {
    if (window.location.pathname.indexOf('/pages/tires') === -1) return;

    var params = new URLSearchParams(window.location.search);
    var year = params.get('year');
    var make = params.get('make');
    var model = params.get('model');

    /* Fallback to sessionStorage */
    if (!year || !make || !model) {
      var saved = loadVehicle();
      if (saved) { year = saved.year; make = saved.make; model = saved.model; }
    }
    if (!year || !make || !model) return;

    var applied = false;
    var attempts = 0;
    var poller = setInterval(function () {
      attempts++;
      if (applied || attempts > 75) { clearInterval(poller); return; } /* 15s max */

      try {
        if (typeof TCWidget !== 'undefined' &&
            TCWidget.loadedApps &&
            TCWidget.loadedApps.TCWidgetSearch &&
            typeof TCWidget.loadedApps.TCWidgetSearch.searchByVehicle === 'function') {
          applied = true;
          clearInterval(poller);
          TCWidget.loadedApps.TCWidgetSearch.searchByVehicle({
            year: String(year),
            make: make,
            model: model
          });
        }
      } catch (e) { /* ignore — user can search manually */ }
    }, 200);
  }

  /* ================================================
     iConfigurator bridge — pre-populate vehicle search
     Runs on /pages/wheels when vehicle data is available.
     iConfigurator is a Vue 2 app at #icm-app-main driven
     by an XState state machine inside VehicleSelect2.
     We must advance the machine through:
       years.ready → selectYear → makes.ready → selectMake →
       models.ready → selectModel → smartSubmodels.ready
     so that the user's submodel pick triggers the full
     cascade (bodyTypes → smartSizes → vehicle → complete).
     ================================================ */
  function initIConfigBridge() {
    if (window.location.pathname.indexOf('/pages/wheels') === -1) return;

    var params = new URLSearchParams(window.location.search);
    var year = params.get('year');
    var make = params.get('make');
    var model = params.get('model');

    /* Fallback to sessionStorage */
    if (!year || !make || !model) {
      var saved = loadVehicle();
      if (saved) { year = saved.year; make = saved.make; model = saved.model; }
    }
    if (!year || !make || !model) return;

    /* Helper: walk Vue component tree to find a component by name */
    function findVueComponent(vm, name, depth) {
      if (depth > 15) return null;
      var cName = (vm.$options && vm.$options.name) || '';
      if (cName === name) return vm;
      if (vm.$children) {
        for (var i = 0; i < vm.$children.length; i++) {
          var found = findVueComponent(vm.$children[i], name, depth + 1);
          if (found) return found;
        }
      }
      return null;
    }

    /* Helper: find key in available object by case-insensitive value match */
    function findKeyByValue(available, targetValue) {
      if (!available) return null;
      var target = targetValue.toUpperCase();
      var keys = Object.keys(available);
      for (var i = 0; i < keys.length; i++) {
        var item = available[keys[i]];
        if (item && item.value && item.value.toUpperCase() === target) return item.key;
      }
      return null;
    }

    /* Helper: poll until the XState machine reaches a given sub-state */
    function waitForState(machine, stateObj, cb, maxMs) {
      if (machine.state.matches(stateObj)) { cb(); return; }
      var elapsed = 0;
      var iv = setInterval(function () {
        elapsed += 100;
        if (machine.state.matches(stateObj)) { clearInterval(iv); cb(); }
        else if (elapsed >= maxMs) { clearInterval(iv); }
      }, 100);
    }

    /* Poll for the Vue app + XState machine to be ready */
    var attempts = 0;
    var poller = setInterval(function () {
      attempts++;
      if (attempts > 100) { clearInterval(poller); return; } /* 20s max */

      var el = document.getElementById('icm-app-main');
      if (!el || !el.__vue__ || !el.__vue__.$store) return;

      var root = el.__vue__;
      var store = root.$store;
      if (!store.state.FitmentGuide2) return;

      /* Find VehicleSelect2 (parent with XState machine) */
      var vs2 = findVueComponent(root, 'VehicleSelect2', 0);
      if (!vs2 || !vs2.machine) return;

      /* Wait until the machine has loaded years */
      if (!vs2.machine.state.matches({years: 'ready'})) return;

      clearInterval(poller);

      /* Find the child select components */
      var yearComp = findVueComponent(root, 'VehicleSelectYear', 0);
      var makeComp = findVueComponent(root, 'VehicleSelectMake', 0);
      var modelComp = findVueComponent(root, 'VehicleSelectModel', 0);
      if (!yearComp || !makeComp || !modelComp) return;

      var state = store.state.FitmentGuide2;
      var machine = vs2.machine;

      try {
        /* Step A — Year: set store value + advance machine */
        var yearObj = state.available.years[year] || state.available.years[String(year)];
        if (!yearObj) return;
        yearComp.selectYear(yearObj.key);   /* Vuex: selected year */
        vs2.selectYear();                    /* Machine: years → makes.loading */

        /* Step B — Make: wait for makes to load, then select */
        waitForState(machine, {makes: 'ready'}, function () {
          var makeKey = findKeyByValue(state.available.makes, make);
          if (makeKey === null) return;
          makeComp.selectMake(makeKey);      /* Vuex: selected make */
          vs2.selectMake();                   /* Machine: makes → models.loading */

          /* Step C — Model: wait for models to load, then select */
          waitForState(machine, {models: 'ready'}, function () {
            var modelKey = findKeyByValue(state.available.models, model);
            if (modelKey === null) return;
            modelComp.selectModel(modelKey); /* Vuex: selected model */
            vs2.selectModel();                /* Machine: models → smartSubmodels.loading */

            /* Machine auto-fetches submodels → smartSubmodels.ready.
               User picks submodel → machine cascades through
               bodyTypes → smartSizes → vehicle → complete. */
          }, 10000);
        }, 10000);
      } catch (e) { /* ignore — user can search manually */ }
    }, 200);
  }

  /* ================================================
     Mobile drawer toggle
     ================================================ */
  function initMobile() {
    var trigger = $('afw-vbar-trigger');
    var bar = $('afw-vbar');
    if (!trigger || !bar) return;

    trigger.addEventListener('click', function () {
      var isOpen = bar.classList.contains('is--open');
      bar.classList.toggle('is--open');
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  function updateTriggerText(year, make, model) {
    var el = $('afw-vbar-trigger-text');
    if (!el) return;
    if (year && make && model) {
      el.textContent = year + ' ' + make + ' ' + model;
    } else {
      el.textContent = 'Find Parts for Your Vehicle';
    }
  }

  /* ================================================
     Clear vehicle — show/hide clear buttons
     ================================================ */
  function showClearButtons() {
    var bar = $('afw-vbar');
    var desktopBtn = $('afw-vbar-clear');
    var mobileBtn = $('afw-vbar-clear-mobile');
    if (desktopBtn) desktopBtn.style.display = '';
    if (mobileBtn) mobileBtn.style.display = '';
    if (bar) bar.classList.add('has--vehicle');
  }

  function hideClearButtons() {
    var bar = $('afw-vbar');
    var desktopBtn = $('afw-vbar-clear');
    var mobileBtn = $('afw-vbar-clear-mobile');
    if (desktopBtn) desktopBtn.style.display = 'none';
    if (mobileBtn) mobileBtn.style.display = 'none';
    if (bar) bar.classList.remove('has--vehicle');
  }

  /* ================================================
     Main init
     ================================================ */
  function init() {
    var bar = $('afw-vbar');
    if (!bar) return;

    var yearSel = $('afw-vbar-year');
    var makeSel = $('afw-vbar-make');
    var modelSel = $('afw-vbar-model');
    var catSel = $('afw-vbar-category');
    var goBtn = $('afw-vbar-go');

    if (!yearSel || !makeSel || !modelSel || !catSel || !goBtn) return;

    /* Populate years (next model year down to 1940) */
    var cy = new Date().getFullYear() + 1;
    for (var y = cy; y >= 1940; y--) addOpt(yearSel, y, y);

    /* Populate makes */
    COMMON_MAKES.forEach(function (m) { addOpt(makeSel, m, m); });

    /* ---------- Event Listeners ---------- */

    function onYearMakeChange() {
      var year = yearSel.value;
      var make = makeSel.value;

      /* Reset downstream */
      modelSel.innerHTML = '<option value="">Model</option>';
      modelSel.disabled = true;
      catSel.disabled = true;
      goBtn.disabled = true;

      if (!year || !make) return;

      fetchModels(make, year, function (models) {
        modelSel.innerHTML = '<option value="">Model</option>';
        if (!models.length) {
          modelSel.innerHTML = '<option value="">No models found</option>';
          return;
        }
        models.forEach(function (m) { addOpt(modelSel, m, m); });
        modelSel.disabled = false;
      });
    }

    yearSel.addEventListener('change', onYearMakeChange);
    makeSel.addEventListener('change', onYearMakeChange);

    modelSel.addEventListener('change', function () {
      var hasModel = !!modelSel.value;
      catSel.disabled = !hasModel;
      goBtn.disabled = true; /* re-require category */
      if (!hasModel) {
        catSel.value = '';
        hideClearButtons();
      } else {
        showClearButtons();
      }
      updateTriggerText(yearSel.value, makeSel.value, modelSel.value);
      saveVehicle(yearSel.value, makeSel.value, modelSel.value);
    });

    catSel.addEventListener('change', function () {
      goBtn.disabled = !catSel.value;
    });

    goBtn.addEventListener('click', function () {
      var y = yearSel.value, m = makeSel.value, md = modelSel.value, c = catSel.value;
      if (y && m && md && c) performSearch(y, m, md, c);
    });

    /* ---------- Clear Vehicle ---------- */
    function clearVehicle(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }

      /* Clear sessionStorage */
      try { sessionStorage.removeItem('afw_vehicle'); } catch (ex) { /* ignore */ }

      /* If the current URL has vehicle params, strip them and reload.
         This clears the search-enhancer heading + filters on /search pages
         and widget pre-population on /pages/wheels and /pages/tires. */
      var url = new URL(window.location.href);
      var hadParams = url.searchParams.has('year') || url.searchParams.has('make') ||
        url.searchParams.has('model') || url.searchParams.has('afw_vbar') ||
        url.searchParams.has('vf_no_match');
      if (hadParams) {
        url.searchParams.delete('year');
        url.searchParams.delete('make');
        url.searchParams.delete('model');
        url.searchParams.delete('afw_vbar');
        url.searchParams.delete('vf_no_match');
        /* On search pages, also clear the vehicle-specific query */
        var path = url.pathname;
        if (path === '/search') {
          url.searchParams.delete('q');
        }
        window.location.href = url.toString();
        return; /* page will reload */
      }

      /* Reset all dropdowns */
      yearSel.value = '';
      makeSel.value = '';
      modelSel.innerHTML = '<option value="">Model</option>';
      modelSel.disabled = true;
      catSel.value = '';
      catSel.disabled = true;
      goBtn.disabled = true;

      /* Reset UI */
      updateTriggerText(null, null, null);
      hideClearButtons();

      /* Close mobile drawer if open */
      if (bar.classList.contains('is--open')) {
        bar.classList.remove('is--open');
        var trigger = $('afw-vbar-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }

    var clearBtn = $('afw-vbar-clear');
    var clearMobileBtn = $('afw-vbar-clear-mobile');
    if (clearBtn) clearBtn.addEventListener('click', clearVehicle);
    if (clearMobileBtn) clearMobileBtn.addEventListener('click', clearVehicle);

    /* ---------- Restore from session ---------- */
    var saved = loadVehicle();
    if (saved && saved.year && saved.make && saved.model) {
      /* Set year */
      yearSel.value = saved.year;
      /* Set make */
      makeSel.value = saved.make;
      /* Fetch and set model */
      fetchModels(saved.make, saved.year, function (models) {
        modelSel.innerHTML = '<option value="">Model</option>';
        models.forEach(function (m) { addOpt(modelSel, m, m); });
        modelSel.disabled = false;
        modelSel.value = saved.model;

        if (modelSel.value === saved.model) {
          catSel.disabled = false;
          updateTriggerText(saved.year, saved.make, saved.model);
          showClearButtons();
        }
      });
    }

    /* ---------- Mobile drawer ---------- */
    initMobile();

    /* ---------- Widget bridges ---------- */
    initTireConnectBridge();
    initIConfigBridge();
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
